(function () {
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  var lastEmail = null;
  function looksLikeEmailField(el){
    if(!el) return false;
    var t=(el.type||'').toLowerCase(); if(t==='email') return true;
    var im=(el.getAttribute&&(el.getAttribute('inputmode')||'')).toLowerCase(); if(im==='email') return true;
    var id=(el.id||'').toLowerCase();
    var name=(el.getAttribute&&(el.getAttribute('name')||'')).toLowerCase();
    var tid=(el.getAttribute&&(el.getAttribute('data-testid')||'')).toLowerCase();
    return id.indexOf('email')>-1||name.indexOf('email')>-1||tid.indexOf('email')>-1;
  }
  function captureFrom(el){
    if(!el||typeof el.value!=='string') return;
    var v=el.value.trim().toLowerCase();
    if(EMAIL_RE.test(v)){ lastEmail=v; }
  }
  function identify(email){
    try{
      if(window.klaviyo&&klaviyo.identify){ klaviyo.identify({email:email}); }
      else { window._learnq=window._learnq||[]; _learnq.push(['identify',{'$email':email}]); }
    }catch(e){}
  }
  document.addEventListener('input', function(e){
    var el=e.composedPath?e.composedPath()[0]:e.target;
    if(looksLikeEmailField(el)) captureFrom(el);
  }, true);
  document.addEventListener('change', function(e){
    var el=e.composedPath?e.composedPath()[0]:e.target;
    if(looksLikeEmailField(el)) captureFrom(el);
  }, true);
  document.addEventListener('click', function(e){
    var path=e.composedPath?e.composedPath():[e.target];
    var isSubmit=path.some(function(n){
      return n&&n.matches&&n.matches('button[type="submit"], input[type="submit"], [data-testid="btn-form-submit"]');
    });
    if(!isSubmit) return;
    if(!lastEmail){
      for(var i=0;i<path.length;i++){
        var n=path[i];
        if(n&&n.querySelector){
          var f=n.querySelector('input#email,[data-testid="field-email"],input[type="email"],input[inputmode="email"],input[name*="email" i]');
          if(f) captureFrom(f);
          if(lastEmail) break;
        }
      }
    }
    if(lastEmail) identify(lastEmail);
  }, true);
  document.addEventListener('submit', function(e){ if(lastEmail) identify(lastEmail); }, true);
})();